const WritingStyles = {
  DEFAULT: "default",
  CONCISE: "concise",
  INFORMAL: "informal",
}

module.exports = {
  WritingStyles,
};